export default __webpack_public_path__ + "static/media/chatwidget-close.b34330b6.svg";